var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coding-apps-websites-programming-hold-code") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.48,
    y: 16.005,
    width: 1.52,
    height: 7.62,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.95,
    y: 23.625,
    width: 1.53,
    height: 3.04,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.95,
    y: 12.955,
    width: 1.53,
    height: 3.05,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.43,
    y: 26.665,
    width: 1.52,
    height: 3.05,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.43,
    y: 11.425,
    width: 1.52,
    height: 1.53,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 29.715,
    width: 1.53,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 20.575,
    width: 1.53,
    height: 3.05,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 16.005,
    width: 1.53,
    height: 3.04,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 9.905,
    width: 1.53,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.38,
    y: 23.625,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.38,
    y: 11.425,
    width: 1.52,
    height: 4.58,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.38,
    y: 5.335,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.86,
    y: 25.145,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.86,
    y: 19.045,
    width: 3.04,
    height: 1.53,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.86,
    y: 6.855,
    width: 1.52,
    height: 1.53,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.86,
    y: 3.815,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.33,
    y: 20.575,
    width: 1.53,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.33,
    y: 8.385,
    width: 1.53,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.33,
    y: 2.285,
    width: 1.53,
    height: 1.53,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.81,
    y: 29.715,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.81,
    y: 22.095,
    width: 1.52,
    height: 1.53,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.81,
    y: 9.905,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.81,
    y: 0.765,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.29,
    y: 23.625,
    width: 1.52,
    height: 6.09,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.76,
    y: 0.765,
    width: 1.53,
    height: 3.05,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.24,
    y: 3.815,
    width: 1.52,
    height: 4.57,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.71,
    y: 8.385,
    width: 1.53,
    height: 3.04,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.19,
    y: 23.625,
    width: 1.52,
    height: 6.09,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.67,
    y: 29.715,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.67,
    y: 22.095,
    width: 1.52,
    height: 1.53,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.67,
    y: 9.905,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.67,
    y: 0.765,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.14,
    y: 20.575,
    width: 1.53,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.14,
    y: 8.385,
    width: 1.53,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.14,
    y: 2.285,
    width: 1.53,
    height: 1.53,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.62,
    y: 25.145,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 19.045,
    width: 3.04,
    height: 1.53,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.62,
    y: 6.855,
    width: 1.52,
    height: 1.53,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.62,
    y: 3.815,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 23.625,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 11.425,
    width: 1.52,
    height: 4.58,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 5.335,
    width: 1.52,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.57,
    y: 29.715,
    width: 1.53,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.57,
    y: 20.575,
    width: 1.53,
    height: 3.05,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.57,
    y: 16.005,
    width: 1.53,
    height: 3.04,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.57,
    y: 9.905,
    width: 1.53,
    height: 1.52,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.05,
    y: 26.665,
    width: 1.52,
    height: 3.05,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.05,
    y: 11.425,
    width: 1.52,
    height: 1.53,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.52,
    y: 23.625,
    width: 1.53,
    height: 3.04,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.52,
    y: 12.955,
    width: 1.53,
    height: 3.05,
    fill: "#78a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16.005,
    width: 1.52,
    height: 7.62,
    fill: "#78a9ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.0a031743f0478850036fadfd060c45f0.svg";
export { ForwardRef as ReactComponent };